import FancyText from "@fuse/sharedComponents/typography/FancyText"

import {
  groupDescBottomGridRow,
  groupDescTopGridRow,
  subTitle,
  title,
} from "@fuse/pages/groupPage/GroupReadyToHang/constant"
import {
  smallHead,
  smallSubTitle,
  topHeading,
  topSubTitle,
} from "@fuse/pages/groupPage/GroupReadyToHang/styles"

import mobileDevice from "@fuse/assets/images/legacy/img-group-view.svg"

const Card = ({ title, subTitle }: { title: string; subTitle: string }) => {
  return (
    <div className="mb-12">
      <FancyText style={smallHead}>{title}</FancyText>
      <FancyText style={smallSubTitle}>{subTitle}</FancyText>
    </div>
  )
}

export const GroupReadyToHang = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="md:mt-[78] mt-[50px] max-w-screen-lg mx-[30px] md:mx-[50px] lg:mx-[100px]">
        <div style={{ marginBottom: 65 }}>
          <FancyText className="text-[42px] md:text-[42px]" style={topHeading}>
            {title}
          </FancyText>
          <FancyText className="text-[16px] md:text-[22px]" style={topSubTitle}>
            {subTitle}
          </FancyText>
        </div>
        <div className="md:flex flex lg:my-[100px]">
          {/* add div here when it's desktop */}
          <div className="flex-1 mb-[10px] hidden lg:flex">
            <img
              src={mobileDevice}
              alt="device"
              className="max-w-xs md:max-w-md p-8 lg:p-0"
            />
          </div>
          <div className="flex-1 md:flex md:justify-center md:items-center lg:ml-[-100px] flex-col">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-8">
              {groupDescTopGridRow.map((item, index) => (
                <Card
                  key={index.toString()}
                  title={item.name}
                  subTitle={item.description}
                />
              ))}
            </div>
            <div className="mb-[10px] lg:hidden items-center justify-center">
              <img
                src={mobileDevice}
                alt="device"
                className="max-w-xs md:max-w-md p-8 lg:p-0"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-8">
              {groupDescBottomGridRow.map((item, index) => (
                <Card
                  key={index.toString()}
                  title={item.name}
                  subTitle={item.description}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
